<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-img
          v-if="heartBeatImgURL"
          v-bind="mainProps"
          :src="heartBeatImgURL"
          rounded="circle"
          alt="Circle image"
        />
      </b-col>
      <b-col>
        <h2>
          {{ recipientNickname }}, you’ve been invited to the family of
          heartbeat {{ heartBeatName }}
        </h2>
        <h6 v-if="expiration">This invitation expires on {{ expiration }}</h6>
        <h6>Not {{ recipientNickname }}? Please ignore this invite.</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3" offset="2">
        <b-img src="/assets/img/appwelcome.jpg" fluid alt="Responsive image" />
      </b-col>
      <b-col style="margin-bottom: 15px;">
        <p>
          Your family member has invited you to be a part of their HeartBeat
          page, a special place where they share their journey and moments that
          matter most. It's a place to connect, celebrate, and support them in
          their ups and downs.
        </p>

        <p>
          By accepting this invitation, you're not just joining a page – you're
          joining a community of love and care. Together, we can create a
          stronger heartbeat for your loved one. Click 'Join' and let's make
          their heart beat with joy. We're all in this together. ❤️
        </p>
        <p>Some of what you get:</p>
        <p>
          1. <strong>Real-time Health Tracking</strong>: Stay updated on your
          loved one's health with real-time data on steps, blood pressure,
          glucose, and weight. You can even connect health devices for
          effortless monitoring.
        </p>
        <p>
          2. <strong>Stay Informed with MyChart</strong>: With our premium plan,
          access Epic MyChart information, including the InBox feature, to keep
          up with you health records seamlessly.
        </p>
        <p>
          3. <strong>Track Progress Together </strong>: Monitor progress in
          cognition games, MyApps usage, and chart progress amongst family
          members and your loved one.
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button
          class="btn-add-crew"
          variant="success"
          @click="handleInvitationResponse(true)"
        >
          Join
        </b-button>
      </b-col>
      <b-col>
        <b-button
          class="btn-add-crew"
          variant="danger"
          @click="handleInvitationResponse(false)"
        >
          No
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RecordViews from "@/mixins/RecordViews";
import moment from "moment";
export default {
  name: "Family_Invite_Notice",
  mixins: [RecordViews],
  components: {},
  props: {
    invitation: {
      type: Object,
      required: true
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
    heartBeatName() {
      return this.invitation &&
        this.invitation.heartbeat &&
        this.invitation.heartbeat.name
        ? this.invitation.heartbeat.name
        : null;
    },
    heartBeatImgURL() {
      return this.invitation &&
        this.invitation.heartbeat &&
        this.invitation.heartbeat.imgURL
        ? this.invitation.heartbeat.imgURL
        : null;
    },
    recipientNickname() {
      return this.invitation &&
        this.invitation.rec &&
        this.invitation.rec.nickname
        ? this.invitation.rec.nickname
        : null;
    },
    expiration() {
      return this.invitation && this.invitation._expire_at
        ? this.formatDate(this.invitation._expire_at)
        : null;
    }
  },
  methods: {
    recordView(publishingId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "invites",
        entityId: publishingId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleInvitationResponse(hasAccepted) {
      this.$emit("invitation-response", hasAccepted);
    },
    formatDate(date) {
      return date
        ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
        : "N/A";
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "JourneyBinder" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      userHasAccepted: null,
      openForm: false,
      mainProps: { blank: false, width: 100, height: 100, class: "m1" },
      invitation: null,
      invitationState: "initial", //initial/rejected/approved
      inviteCode: null
    };
  }
};
</script>
